import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  increment,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "./firebase";

function cartItemRef(uid, productId) {
  return doc(db, "users", uid, "cart", String(productId));
}

function cartCollection(uid) {
  return collection(db, "users", uid, "cart");
}

function productRef(productId) {
  return doc(db, "products", String(productId));
}

function toQuantity(value, fallback = 1) {
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  return Math.max(0, Math.floor(num));
}

export async function getCart(uid) {
  const cartSnapshot = await getDocs(cartCollection(uid));
  const rawItems = cartSnapshot.docs.map((d) => ({
    product_id: d.id,
    quantity: toQuantity(d.data()?.quantity, 1),
  }));

  const resolved = await Promise.all(
    rawItems.map(async (item) => {
      const pSnap = await getDoc(productRef(item.product_id));
      if (!pSnap.exists()) return null;
      const p = pSnap.data() || {};
      return {
        product_id: item.product_id,
        quantity: item.quantity,
        product: {
          id: pSnap.id,
          name: p.name || "",
          category: p.category || "adult",
          image_url: p.image_url || "",
          price: Number(p.price) || 0,
          stock: Number(p.stock) || 0,
        },
      };
    })
  );

  const items = resolved.filter(Boolean);
  const total = items.reduce((sum, it) => sum + it.product.price * it.quantity, 0);
  return { items, total };
}

export async function addCartItem(uid, productId, quantity = 1) {
  const qty = toQuantity(quantity, 1);
  if (qty <= 0) return;
  await setDoc(
    cartItemRef(uid, productId),
    {
      product_id: String(productId),
      quantity: increment(qty),
      updated_at: serverTimestamp(),
    },
    { merge: true }
  );
}

export async function setCartItemQuantity(uid, productId, quantity) {
  const qty = toQuantity(quantity, 0);
  if (qty <= 0) {
    await deleteDoc(cartItemRef(uid, productId));
    return;
  }
  await setDoc(
    cartItemRef(uid, productId),
    {
      product_id: String(productId),
      quantity: qty,
      updated_at: serverTimestamp(),
    },
    { merge: true }
  );
}

export async function removeCartItem(uid, productId) {
  await deleteDoc(cartItemRef(uid, productId));
}
